import { NavLink } from "react-router-dom";
import styles from './desktopNavbar.module.css';
import { useContext } from "react";
import { HiChevronDown } from "react-icons/hi";
import AppContext from "../../contexts/Appcontext";


export default function DesktopNavbar() {

  const { productsCategory } = useContext(AppContext);

  function activeLinkStyler(isActive) {
    return (isActive ? { borderBottom: '1px solid var(--activeMenuColor)' } : {});
  }

  function submenuActiveLinkStyler(isActive) {
    return (isActive ? { color: 'var(--darkOrange)' } : {});
  }

  return (
    <nav className={`${styles.navbar} d-none d-lg-block`}>
      <ul className='d-flex gap-1'>
        <li className={styles.menuItem1}><NavLink to='/' style={({ isActive }) => activeLinkStyler(isActive)}>خانه</NavLink></li>
        <li className={styles.menuItem1}>
          <a href='#'><HiChevronDown className='ms-1' />محصولات</a>
          <ul className={styles.menuContainer2}>
            {productsCategory.map(category =>
              <li key={category.id}>
                <NavLink to={`/products/${category.slug}`} style={({ isActive }) => submenuActiveLinkStyler(isActive)}>
                  {category.name}
                </NavLink>
              </li>
            )}
          </ul>
        </li>
        <li className={styles.menuItem1}><NavLink to='/protocols' style={({ isActive }) => activeLinkStyler(isActive)}>پروتکل</NavLink></li>
        <li className={styles.menuItem1}><NavLink to='/contactUs' style={({ isActive }) => activeLinkStyler(isActive)}>تماس</NavLink></li>
        <li className={styles.menuItem1}><NavLink to='/aboutUs' style={({ isActive }) => activeLinkStyler(isActive)}>درباره ما</NavLink></li>
      </ul>
    </nav>
  )
}